import ApiBase from '../ApiBase';

export default new class Section extends ApiBase {
    route = '/surveys/:survey/sections';
}
